import React, { useState } from 'react';
import { PIECE_SRC } from './pieces.mjs';
import { PIECE_NAMES } from './commandParser.mjs';

const FILES = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];

// board: chess.js .board() output — ranks 8→1, each cell null or
// { square, type, color }.
// onMove(from, to): called for drag-and-drop and click-click moves.
export default function Board({ board, flipped, lastMove, checkSquare, onMove }) {
  const [selected, setSelected] = useState(null);
  const [dragOver, setDragOver] = useState(null);

  let rows = board.map((rank, r) =>
    rank.map((cell, f) => ({
      cell,
      square: FILES[f] + (8 - r),
      light: (r + f) % 2 === 0,
    }))
  );
  if (flipped) {
    rows = rows
      .slice()
      .reverse()
      .map((rank) => rank.slice().reverse());
  }

  const tryMove = (from, to) => {
    setSelected(null);
    setDragOver(null);
    if (from && to && from !== to && onMove) onMove(from, to);
  };

  const handleClick = (square, cell) => {
    if (selected) {
      if (selected === square) {
        setSelected(null); // tap again to deselect
      } else {
        tryMove(selected, square);
      }
    } else if (cell) {
      setSelected(square);
    }
  };

  return (
    <div className="vc-board" role="img" aria-label="Chess board">
      {rows.map((rank) =>
        rank.map(({ cell, square, light }) => {
          const classes = ['vc-square', light ? 'light' : 'dark'];
          if (lastMove && (square === lastMove.from || square === lastMove.to)) {
            classes.push('last-move');
          }
          if (checkSquare === square) classes.push('in-check');
          if (selected === square) classes.push('selected');
          if (dragOver === square) classes.push('drag-over');
          return (
            <div
              key={square}
              data-square={square}
              className={classes.join(' ')}
              onClick={() => handleClick(square, cell)}
              onDragOver={(e) => {
                e.preventDefault();
                setDragOver(square);
              }}
              onDragLeave={() => setDragOver((cur) => (cur === square ? null : cur))}
              onDrop={(e) => {
                e.preventDefault();
                tryMove(e.dataTransfer.getData('text/plain'), square);
              }}
            >
              {cell && (
                <img
                  className="vc-piece"
                  src={PIECE_SRC[cell.color + cell.type]}
                  alt={`${cell.color === 'w' ? 'White' : 'Black'} ${PIECE_NAMES[cell.type]}`}
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData('text/plain', square);
                    e.dataTransfer.effectAllowed = 'move';
                    setSelected(square);
                  }}
                  onDragEnd={() => {
                    setSelected(null);
                    setDragOver(null);
                  }}
                />
              )}
              {square[0] === (flipped ? 'h' : 'a') && (
                <span className="vc-coord rank">{square[1]}</span>
              )}
              {square[1] === (flipped ? '8' : '1') && (
                <span className="vc-coord file">{square[0]}</span>
              )}
            </div>
          );
        })
      )}
    </div>
  );
}
